import { LocalPoi } from '../interface/LocalPoi';
import { OSMPoi } from '../interface/OSMPoi';

export const getOSMPOI = async (
  auth: string,
  min_lat: number,
  min_long: number,
  max_lat: number,
  max_long: number
): Promise<LocalPoi[] | string> => {
  const { REACT_APP_API_URL } = process.env;
  try {
    const response = await fetch(
      `${REACT_APP_API_URL}/osm/?min_lat=${min_lat}&min_long=${min_long}&max_long=${max_long}&max_lat=${max_lat}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: auth,
        },
      }
    );

    const data = await response.json();
    if (response.ok) {
      return data.map((item: OSMPoi) => ({
        id: item.id,
        title: item.name == null ? `#${item.osm_id}` : item.name,
        osm_type: item.osm_type,
        tags: item.tags,
        category: item.category,
        longitude: item.longitude,
        latitude: item.latitude,
        osm_id: item.osm_id,
      }));
    } else {
      return data.message || 'Failed to fetch OSM POIs';
    }
  } catch (error) {
    return (error as Error).message || 'Unknown error';
  }
};
